import { Field } from 'formik'
import SkeletonLoader from '@/Layout/SkeletonLoader'

const FormikSelect = (props) => {
    const { selectProps, customClass, children, skeletonLoading } = props
    return (
        <>
            {
                skeletonLoading ? <SkeletonLoader height={54} rows={1} /> :
                    <Field as="select" {...selectProps} className={`${customClass} appearance-none border border-neutral-200 rounded-full w-full py-3 px-4 pr-8 md:text-sm text-xs text-neutral-700 font-medium placeholder:text-neutral-400 placeholder:font-normal focus:outline-none focus:border-primary/60 focus:ring-4 focus:ring-primary/15 focus-visible:outline-none bg-[url('/assets/images/select-arrow.svg')] bg-no-repeat bg-[95%] bg-white transition-all duration-150 *:bg-white *:px-2 *:py-1`}>
                        {children}
                    </Field>
            }
        </>
    )
}

export default FormikSelect
